import React from 'react'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import CustomerServiceLayoutDefault from '../layout/default'
import CMSContent from '../../../components/cms-content'

const CustomerServiceCmsContentPage = () => {
    const pageConfig = useCustomerServicePageConfig()
    const {id, content} = pageConfig
    const {body, ...rest} = content

    return (
        <CustomerServiceLayoutDefault maxWidth={'100%'} px={{base: 4, lg: '6.5rem', xl: 0}}>
            <CMSContent data-testid="content-page" id={id} content={{...rest, c_body: body}} />
        </CustomerServiceLayoutDefault>
    )
}

export default CustomerServiceCmsContentPage
